import { Channel } from '../../../../shared/types';
import { randomizeArray, sliceArray } from '../../../../utils/utils';

export interface ChannelsGridProps {
    randomize?: boolean;
    quantityToDisplay?: number;
}

export const randomizeChannels = (channels: Channel[] = []): Channel[] =>
    randomizeArray(channels);

export const prepareChannelsToShow = (
    channels?: Channel[],
    randomize?: boolean,
    quantityToDisplay?: number
) => {
    let outChannels = channels;

    if (randomize) {
        outChannels = randomizeChannels(channels);
    }

    if (quantityToDisplay) {
        return sliceArray(outChannels, quantityToDisplay);
    }

    return outChannels;
};
